module.exports = __webpack_public_path__ + "img/hb.825ad9a9.png";